"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.runWithLowPriority = void 0;

var Scheduler = _interopRequireWildcard(require("scheduler"));

var runWithLowPriority = function runWithLowPriority(cb) {
  return Scheduler.unstable_runWithPriority(Scheduler.unstable_LowPriority, function () {
    cb();
  });
};

exports.runWithLowPriority = runWithLowPriority;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/react-rhumb/static-1.5065/js/internal/Scheduler.js
// module id = 338
// module chunks = 209 210 211 212